import { SET_AUDIT_LOGS, SET_AUDIT_FILTERS } from "./types";

const initialState = {
  logs: [],
  total: 0,
  modules: [],
  actions: [],
};

const auditLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUDIT_LOGS:
      return {
        ...state,
        logs: action.payload.data,
        total: action.payload.total,
      };
    case SET_AUDIT_FILTERS:
      return {
        ...state,
        modules: action.payload.modules,
        actions: action.payload.actions,
      };
    default:
      return state;
  }
};

export default auditLogReducer;
